import merge from "lodash/merge"
import MarkdownToJSX from "markdown-to-jsx"

import { cn } from "@/lib/utils"

export const Markdown = ({
  className,
  options,
  ...props
}: React.ComponentProps<typeof MarkdownToJSX>) => {
  return (
    <MarkdownToJSX
      className={cn("mb-3 space-y-3", className)}
      options={merge(
        {
          overrides: {
            ol: {
              props: {
                className: "list-outside list-decimal pl-4",
              },
            },
            ul: {
              props: {
                className: "list-outside list-disc pl-4",
              },
            },
            li: {
              props: {
                className: "",
              },
            },
            blockquote: {
              props: {
                className: "pl-3 border-l-2 border-border",
              },
            },
            h1: {
              props: { className: "text-h1 text-[32px] font-medium" },
            },
            h2: {
              props: { className: "text-h2 text-[28px] font-medium" },
            },
            h3: {
              props: { className: "text-h3 text-[24px] font-medium" },
            },
            h4: {
              props: { className: "text-h4 text-[18px] font-medium" },
            },
            a: {
              props: {
                className:
                  "border-b border-solid border-b-current text-link visited:text-link hover:text-foreground aria-disabled:text-muted-foreground/50",
              },
            },
          },
        },
        options,
      )}
      {...props}
    />
  )
}
